<template>
    <div class="ImgContentGray">
        <div class="ImgContent">
            <div class="ImgTitle">
                关注圆桌星球，获取最新动态
            </div>
            <div class="ImgContentImg"">
                <div class=" Imgone">

            </div>
            <div class="Imgtwo">

            </div>
            <div class="Imgthree">

            </div>
            <div class="Imgfour">

            </div>
            <div class="Imgfive">

            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {

    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.ImgContentGray {
    width: 100%;
    background-color: #f6f7fa;
}

.ImgContent {
    width: 1200px;
    height: 573px;
    margin: auto;
    display: flex;
    justify-content: center;
    position: relative;
}

.ImgTitle {
    position: absolute;
    top: 100px;
    width: 1200px;
    height: 55px;
    font-family: 'JjyHeave';
    font-size: 40px;
    line-height: 55px;
    font-weight: 900;
}

.ImgContentImg {
    position: absolute;
    top: 220px;
    width: 1200px;
    height: 218px;
    display: flex;
    justify-content: space-between;
}

.Imgone {
    width: 200px;
    height: 218px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E5%85%AC%E4%BC%97%E5%8F%B7.png');
    background-size: cover;
    background-position: center;
}

.Imgone:hover {
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E5%85%AC%E4%BC%97%E5%8F%B72.png');
    animation: fadeIn 1.5s forwards;
    position: relative;
}

.Imgone:hover::after {
    position: absolute;
    content: '';
    width: 400px;
    height: 400px;
    top: -330px;
    left: -100px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E5%8E%8B%E7%BC%A9%E4%BA%8C%E7%BB%B4%E7%A0%81/%E9%A6%96%E9%A1%B5%E4%BA%8C%E7%BB%B4%E7%A0%81/11.png');
    background-size: cover;
    background-position: center;
    animation: ScaleIn 0.5s forwards;
}

.Imgtwo {
    width: 200px;
    height: 218px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E8%A7%86%E9%A2%91%E5%8F%B7.png');
    background-size: cover;
    background-position: center;

}

.Imgtwo:hover {
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E8%A7%86%E9%A2%91%E5%8F%B72.png');
    animation: fadeIn 1.5s forwards;
    position: relative;
}

.Imgtwo:hover::after {
    position: absolute;
    content: '';
    width: 400px;
    height: 400px;
    top: -330px;
    left: -100px;

    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E5%8E%8B%E7%BC%A9%E4%BA%8C%E7%BB%B4%E7%A0%81/%E9%A6%96%E9%A1%B5%E4%BA%8C%E7%BB%B4%E7%A0%81/22.png');
    background-size: cover;
    background-position: center;
    animation: ScaleIn 0.5s forwards;
}

.Imgthree {
    width: 200px;
    height: 218px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E5%A4%A9%E7%8C%AB.png');
    background-size: cover;
    background-position: center;
}

.Imgthree:hover {
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E5%A4%A9%E7%8C%AB2.png');
    animation: fadeIn 1.5s forwards;
    position: relative;
}

.Imgthree:hover::after {
    position: absolute;
    content: '';
    width: 400px;
    height: 400px;
    top: -330px;
    left: -100px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E5%8E%8B%E7%BC%A9%E4%BA%8C%E7%BB%B4%E7%A0%81/%E9%A6%96%E9%A1%B5%E4%BA%8C%E7%BB%B4%E7%A0%81/44.png');
    background-size: cover;
    background-position: center;
    animation: ScaleIn 0.5s forwards;
}

.Imgfour {
    width: 200px;
    height: 218px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E5%B0%8F%E7%BA%A2%E4%B9%A6.png');
    background-size: cover;
    background-position: center;

}

.Imgfour:hover {
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E5%B0%8F%E7%BA%A2%E4%B9%A62.png');
    animation: fadeIn 1s forwards;
    position: relative;
}

.Imgfour:hover::after {
    position: absolute;
    content: '';
    width: 400px;
    height: 400px;
    top: -330px;
    left: -100px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E5%8E%8B%E7%BC%A9%E4%BA%8C%E7%BB%B4%E7%A0%81/%E9%A6%96%E9%A1%B5%E4%BA%8C%E7%BB%B4%E7%A0%81/33.png');
    background-size: cover;
    background-position: center;
    animation: ScaleIn 0.5s forwards;
}

.Imgfive {
    width: 200px;
    height: 218px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E6%8A%96%E9%9F%B3.png');
    background-size: cover;
    background-position: center;
}

.Imgfive:hover {
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E6%8A%96%E9%9F%B32.png');
    animation: fadeIn 1s forwards;
    position: relative;
}

.Imgfive:hover::after {
    position: absolute;
    content: '';
    width: 400px;
    height: 400px;
    top: -330px;
    left: -100px;
    background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E5%8E%8B%E7%BC%A9%E4%BA%8C%E7%BB%B4%E7%A0%81/%E9%A6%96%E9%A1%B5%E4%BA%8C%E7%BB%B4%E7%A0%81/%E6%8A%96%E9%9F%B3%E4%B8%BB%E9%A1%B5.png');
    background-size: cover;
    background-position: center;
    animation: ScaleIn 0.5s forwards;
}

/* @keyframes fadeIn {
    from {
        opacity: 0.8;

    }

    to {
        opacity: 1;
    }
} */

@keyframes ScaleIn {
    from {
        transform: scale(0.9);
    }

    to {
        transform: scale(1);
    }
}
</style>
